import React from 'react';

const ViewQuestionModal = ({ isOpen, questions, onClose }) => {
  if (!isOpen || !questions) return null;

  const { question, options, correctAnswer } = questions;
  console.log('Viewing question:', options, correctAnswer);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg max-w-xl w-full shadow-lg">
        <h2 className="text-xl font-bold mb-6 text-center">Question Details</h2>

        {/* Question */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Question:</label>
          <input
            type="text"
            readOnly
            value={question}
            className="w-full px-3 py-2 border rounded bg-gray-100 border-gray-300 text-gray-800"
          />
        </div>

        {/* Options */}
        <div className="mb-4">
          <div className="space-y-3">
            {Array.isArray(options) &&
              options.map((opt, index) => (
                <div key={opt._id || index}>
                  <label className="block text-sm text-gray-600 mb-1">
                    <p className="text-sm font-medium text-gray-700 mb-2">
                      Options: {String.fromCharCode(65 + index)}.
                    </p>
                  </label>
                  <input
                    type="text"
                    readOnly
                    value={opt.text}
                    className={`w-full px-3 py-2 border rounded bg-gray-100 ${
                      opt.isCorrect
                        ? 'border-green-500 text-green-700 font-semibold'
                        : 'border-gray-300 text-gray-800'
                    }`}
                  />
                </div>
              ))}
          </div>
        </div>

        {/* Correct Answer */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-1">Correct Answer:</label>
          <input
            type="text"
            readOnly
            value={correctAnswer}
            className="w-full px-3 py-2 border rounded bg-gray-100 border-green-500 text-green-700 font-semibold"
          />
        </div>

        {/* Close Button */}
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewQuestionModal;
